import ExpenseCategory from './models'

export default ExpenseCategory
